/**
 * База API собственного бэкенда модуля — всегда origin самого ремоута.
 *
 * В embed наш код исполняется на СТРАНИЦЕ ПЛАТФОРМЫ, поэтому относительный
 * '/api' ушёл бы на её домен, а не к нам. Ассеты ремоута приезжают со своего
 * origin (`publicPath: 'auto'`), и `resolveRemoteApiBase` выводит базу из
 * `import.meta.url` — одно значение верно и в standalone, и в embed, и на любом
 * окружении без пересборки.
 *
 * `suffix: ''`, потому что пути клиента уже несут '/api' (иначе вышло бы '/api/api').
 *
 * Ни `window.__RUNTIME_CONFIG__`, ни `VITE_API_URL` здесь больше нет: первый в
 * embed принадлежит странице платформы и увёл бы запросы на её бэкенд, второй
 * вшивается на сборке и не может быть верным сразу для обоих режимов.
 *
 * Прямой импорт `@aseller/host-contract` — единственное исключение из правила
 * «пакет импортируется только в app/contract.ts»: слой `shared` не имеет права
 * знать о слое `app` (STRUCTURE.md), а обратной дороги у резолва базы нет.
 * Так же устроен канон — `nichecompare_mf/frontend/src/api/client.ts`.
 */

import { resolveRemoteApiBase } from '@aseller/host-contract';

export const API_URL = resolveRemoteApiBase({ suffix: '' });
